<template>
  <v-card-text class="test0">
    <span>Ebenentransparenz</span>
    <v-slider color="onprimary" prepend-icon="opacity" :value="layer.getOpacity()" min="0" max="1" step="0.01"
      thumb-label hide-details @input="onOpacitySliderInput" show-ticks="always" track-size="8">
    </v-slider>
  </v-card-text>
</template>

<script>
export default {
  name: 'wgu-layeropacitycontrolcustom',
  props: {
    layer: { type: Object, required: true }
  },
  methods: {
    /**
     * Handler for input on the opacity slider, updates the layer`s opacity.
     */
    onOpacitySliderInput (value) {
      this.layer.setOpacity(value);
    }
  }
}
</script>

<style>

.v-slider--horizontal {
  margin-right: 16px;
}

.test0 {
  margin-bottom: 1em;
}

.test0:hover {
  background-color: #F2F2F2;
}

.v-input__icon--prepend .v-icon  {
  color: #00508c;
}

</style>

<style scoped>
</style>
